<section class="py-10 lg:py-20 px-3 md:px-5 2xl:px-28 3xl:px-52">
  <div
    class="container mx-auto bg-OUT-BlueBlack flex flex-col lg:flex-row items-center justify-center overflow-hidden min-h-[45vh] rounded-2xl"
  >
    <div
      class="text-white text-center lg:text-start py-10 px-3 lg:p-7 flex flex-col items-center md:items-start gap-4 w-full lg:w-[55%]"
    >
      <h3 class="text-2xl lg:text-4xl font-semibold">
        <span class="text-OUT-Light-Blue">Ready to Sell Your Tesla?</span> Begin
        your journey with Only Used Tesla!
      </h3>
      <p>
        Simply Register or Login. It's fast, easy, and your ticket to a
        hassle-free Tesla selling experience. Welcome aboard!
      </p>
      <button
        *ngIf="(auth.isAuthenticated$ | async) === false"
        class="bg-OUT-Blue hover:bg-OUT-Blue/90 font-semibold transition-colors duration-300 rounded-full py-3 px-3 lg:px-5 text-sm lg:text-base cursor-pointer w-fit"
        (click)="login()"
      >
        Register or Log in to start selling your Tesla
      </button>
      <button
        *ngIf="(auth.isAuthenticated$ | async) === true"
        class="bg-OUT-Blue hover:bg-OUT-Blue/90 font-semibold w-fit transition-colors duration-400 rounded-full px-4 py-2 text-white font-semibold cursor-pointer"
        [routerLink]="
          (auth.isAuthenticated$ | async) ? '/your-tesla' : '/sell-my-tesla'
        "
      >
        Sell My Tesla
      </button>
    </div>
    <div
      class="w-full h-full lg:w-[50%] bg-[url('/assets/images/Model3_63.webp')] bg-cover bg-center min-h-[40vh] md:min-h-[45vh]"
    ></div>
  </div>
</section>
